import React from 'react';
import { VariableType } from '../types/dashboard.types';

interface VariableSelectorProps {
  selectedVariable: VariableType;
  onSelectionChange: (selection: 'wind' | 'solar' | 'temperature') => void;
}

const VariableSelector: React.FC<VariableSelectorProps> = ({
  selectedVariable,
  onSelectionChange,
}) => {
  return (
    <div className="flex items-center gap-2">
      <label className="text-xs font-medium text-gray-600 dark:text-gray-400 whitespace-nowrap">
        Variable
      </label>
      <div className="flex bg-gray-100 dark:bg-gray-800 rounded-md">
        {[
          { id: 'wind', label: 'Wind' },
          { id: 'solar', label: 'Solar' },
          { id: 'temperature', label: 'Temperature' },
        ].map((option) => (
          <button
            key={option.id}
            onClick={() => onSelectionChange(option.id as 'wind' | 'solar' | 'temperature')}
            className={`px-3 py-1 text-xs font-medium rounded transition-colors whitespace-nowrap ${
              selectedVariable === option.id
                ? 'bg-gray-900 dark:bg-gray-600 text-white shadow-sm'
                : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100'
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default VariableSelector;
